import React, { useState } from "react";
import Slider from "react-slick";
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faChevronRight, faChevronLeft } from '@fortawesome/free-solid-svg-icons';

const settings = {
  dots: true,
  infinite: true,
  speed: 1700,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  autoplaySpeed: 5000,
  autoplay: true,
  // nextArrow: <FontAwesomeIcon icon={faChevronRight} />,
  // prevArrow: <FontAwesomeIcon icon={faChevronLeft} />
};

const bannerImages = [
  "/assets/images/main-banner.jpg",
  "/assets/images/banner-second.jpg",
  "/assets/images/banner-third.jpg",
];

const containerStyle: React.CSSProperties = {
  height: "60vh",
  width: "100%",
  overflow: "hidden",
};

const slideStyle: React.CSSProperties = {
  height: "60vh",
  width: "100%",
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
};

export default function HomeBannerSlider() {
  return (
    <div style={containerStyle}>
      <style>
        {`
          .banner-slider .slick-slider,
          .banner-slider .slick-list,
          .banner-slider .slick-track {
            height: 60vh !important;
          }
          .banner-slider .slick-slide {
            height: 60vh !important;
          }
          .banner-slider .slick-slide > div {
            height: 60vh !important;
            width: 100% !important;
          }
          .banner-slider .slick-dots {
            bottom: 20px;
            z-index: 10;
          }
          .banner-slider .slick-dots li button:before {
            color: white;
            font-size: 14px;
            opacity: 0.75;
          }
          .banner-slider .slick-dots li.slick-active button:before {
            color: white;
            opacity: 1;
          }
        `}
      </style>
      <Slider {...settings} className="banner-slider">
        {bannerImages.map((image, index) => (
          <div key={index}>
            <div
              style={{
                ...slideStyle,
                backgroundImage: `url(${image})`,
              }}
            />
          </div>
        ))}
      </Slider>
    </div>
  );
}
